var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"light":""}},[_c('tool-bar'),_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('transition',{attrs:{"name":"page","mode":"out-in"}},[_c('router-view')],1)],1)],1),_c('feedback-message'),_c('page-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }